import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bnt-imprimir',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bnt-imprimir.component.html',
  styleUrls: ['./bnt-imprimir.component.scss'],
})
export class BntImprimirComponent {
  /**
   * Controla se o botão está desabilitado de verdade (bloqueia o clique
   * nativamente — para regras de acesso, onde não faz sentido reagir ao
   * clique de forma alguma).
   */
  @Input() disabled: boolean = false;
  /**
   * Deixa o botão com aparência "apagada" sem bloquear o clique — usado
   * quando o clique deve continuar chegando no pai para que ele avise o
   * usuário (ex: "selecione uma obra"), em vez de travar silenciosamente.
   */
  @Input() esmaecido: boolean = false;
  /**
   * Texto do botão
   */
  @Input() label: string = '';
  /**
   * Caminho do ícone
   */
  @Input() icon: string = '';
  /**
   * Evento disparado ao clicar
   */
  @Output() imprimir = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.imprimir.emit();
    }
  }
}
